import { useState, type ReactNode } from "react";
import type { IPatientId } from "@medoma/models/patients";
import { TemplatesContext } from "./TemplatesContext";

export const TemplatesContextProvider = ({
  children,
  initialPatientId,
  initialDefaultStartDate,
}: {
  children: ReactNode;
  initialPatientId: IPatientId;
  initialDefaultStartDate: Date | undefined;
}) => {
  const [patientId, setPatientId] = useState<IPatientId>(initialPatientId);

  return (
    <TemplatesContext.Provider
      value={{
        selectedPatientId: patientId,
        setSelectedPatientId: setPatientId,
        defaultStartDate: initialDefaultStartDate,
      }}
    >
      {children}
    </TemplatesContext.Provider>
  );
};
